/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Store, select } from "@ngrx/store";
import * as UserAuthActions from "../../../state/actions/user-authentification.actions";
import { UserState } from "src/app/state/user-state";
import { DialogService } from "src/app/core/services/dialog.service";
import { EmailValidator } from "./emailValidator.validator";
import { Observable, Subscription } from "rxjs";
import { selectAuthError } from "src/app/state/reducer/user.reducer";
import { SpinnerService } from "src/app/core/services/spinner.service";
import { ICONS } from "src/app/core/constants/icons";
import { ROUTES } from "src/app/core/constants/routes";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit, OnDestroy {

  $loginError: Observable<string | undefined> = this.store.pipe(select(selectAuthError));

  loginForm = this.formBuilder.group({
    email: ["", [Validators.required, Validators.email, EmailValidator]],
    password: ["", [Validators.required]]
  });

  submitted = false;
  loginError: string | undefined;
  subscription: Subscription | undefined;

  LOGO = ICONS.NEW_LOGO;
  USERNAME = ICONS.NEW_USERNAME;
  PASSWORD = ICONS.NEW_PASSWORD;
  REGISTER_ROUTE = ROUTES.REGISTER;
  PASSWORD_RECOVERY_ROUTE = ROUTES.PASSWORD_RECOVERY;
  ABOUT_APP = ROUTES.LOGIN_ABOUT_APP;

  isEmailInputFocused = false;
  isPasswordInputFocused = false;

  constructor(private store: Store<UserState>,
    private formBuilder: FormBuilder,
    protected dialogService: DialogService,
    protected spinnerService: SpinnerService) {
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.spinnerService.showSpinner();
      const username = this.loginForm.value.email as string;
      const password = this.loginForm.value.password as string;
      this.store.dispatch(UserAuthActions.USER_LOGIN({ username, password }));
    }
  }

  ngOnInit() {
    this.spinnerService.hideSpinner();
    this.store.dispatch(UserAuthActions.RESET_AUTH_ERROR_MESSAGE());
    this.subscription = this.$loginError.subscribe((loginError) => {
      this.loginError = loginError;
    });
  }

  get getLoginForm() {
    return this.loginForm.controls;
  }

  inputChanged(event: any) {
    if (this.loginError !== "")
      this.store.dispatch(UserAuthActions.RESET_AUTH_ERROR_MESSAGE());
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}